import { AsyncPipe, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ALTabsComponent } from '@asamco/application-link/shared';
import { AdminAuditLogsCompaniesUsersComponent } from '../admin-audit-logs-companies-users/admin-audit-logs-companies-users.component';
import { AdminAuditUserManagementComponent } from '../admin-audit-user-management/admin-audit-user-management.component';
import { AdminAuditLogsLinksComponent } from '../admin-audit-logs-links/admin-audit-logs-links.component';
import { AdminAuditLogsLinksLinksettingsUpdatesComponent } from '../admin-audit-logs-links-linksettings-updates/admin-audit-logs-links-linksettings-updates.component';
import { AdminAuditLogsPermissionsComponent } from '../admin-audit-logs-permissions/admin-audit-logs-permissions.component';
import { AdminAuditLogsFunctionappComponent } from '../admin-audit-logs-functionapp/admin-audit-logs-functionapp.component';

@Component({
	selector: 'app-shell-admin-audit-logs-overview',
	templateUrl: './admin-audit-logs-overview.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		NgSwitch,
		NgSwitchCase,
		AsyncPipe,
		ALTabsComponent,
		AdminAuditLogsCompaniesUsersComponent,
		AdminAuditUserManagementComponent,
		AdminAuditLogsLinksComponent,
		AdminAuditLogsLinksLinksettingsUpdatesComponent,
		AdminAuditLogsPermissionsComponent,
		AdminAuditLogsFunctionappComponent,
	],
})
export class AdminAuditLogsOverviewComponent {
	public readonly tabInfoAuditLogs = [
		{
			id: 1,
			text: 'Companies & Users',
			icon: 'far fa-users',
		},
		{
			id: 2,
			text: 'User management',
			icon: 'far fa-link',
		},
		{
			id: 3,
			text: 'Links - [Creation & Deletion]',
			icon: 'far fa-link',
		},
		{
			id: 4,
			text: 'Links & Link settings - [Updates]',
			icon: 'far fa-link',
		},
		{
			id: 5,
			text: 'Permissions',
			icon: 'far fa-link',
		},
		{
			id: 6,
			text: 'Function app',
			icon: 'far fa-link',
		},
	];

	public readonly selectedAuditLogsTab$ = new BehaviorSubject(1);
}
